module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_8011.cb3d0362.png";